import { Address } from "./user";

export enum TicketStatusEnum {
  Active = "active",
  ReceivedByTransfer = "received_by_transfer",
  NoIssues = "no issues",
  PaymentNotCompleted = "Payment not completed",
  MissingUserInformation = "Missing user information",
  PendingIssues = "Pending issues",
  AlreadyUsed = "already used",
  TransferInProgress = "transfer_in_progress",
  Transferred = "transferred",
  Cancelled = "cancelled",
}

interface BaseOrderTicket {
  id: number;
  price: string;
  user_name?: string;
  user_last_name?: string;
  user_cpf?: string;
  user_identity_card?: string;
  user_email?: string;
  title: string;
  description: string;
  tax: string;
  pdv_fee_cents?: number | null;
  pdv_customer_fee_cents?: number | null;
  consumption?: string;
  ticket_type?: string;
  space_id?: number;
  event?: Event;
  event_id: number;
  event_title: string;
  event_description: string;
  event_thumbnail: string;
  event_start_date: string;
  event_end_date: string;
  transferable: boolean;
  qr_code?: string;
  event_location: Address;
  transferred_from?: boolean;
  transfer_origin_name?: string;
  transfer_origin_email?: string;
}

export interface ActiveOrderTicket extends BaseOrderTicket {
  status:
    | TicketStatusEnum.Active
    | TicketStatusEnum.NoIssues
    | TicketStatusEnum.ReceivedByTransfer;
}

export interface PaymentNotCompletedOrderTicket extends BaseOrderTicket {
  status: TicketStatusEnum.PaymentNotCompleted;
}

export interface MissingUserInformationOrderTicket extends BaseOrderTicket {
  status: TicketStatusEnum.MissingUserInformation;
}

export interface PendingIssuesOrderTicket extends BaseOrderTicket {
  status: TicketStatusEnum.PendingIssues;
}

export interface AlreadyUsedOrderTicket extends BaseOrderTicket {
  status: TicketStatusEnum.AlreadyUsed;
}

export interface TransferInProgressOrderTicket extends BaseOrderTicket {
  status: TicketStatusEnum.TransferInProgress;
  recipient_email: string;
  transfer_id: number;
}

export interface TransferredOrderTicket extends BaseOrderTicket {
  status: TicketStatusEnum.Transferred;
  transferred_to_email: string;
  transferred_to_name: string;
}

export interface CancelledOrderTicket extends BaseOrderTicket {
  status: TicketStatusEnum.Cancelled;
}

export type OrderTicket =
  | ActiveOrderTicket
  | PaymentNotCompletedOrderTicket
  | MissingUserInformationOrderTicket
  | PendingIssuesOrderTicket
  | AlreadyUsedOrderTicket
  | TransferInProgressOrderTicket
  | TransferredOrderTicket
  | CancelledOrderTicket;

export function isTransferInProgressTicket(
  ticket: OrderTicket,
): ticket is TransferInProgressOrderTicket {
  return ticket.status === TicketStatusEnum.TransferInProgress;
}

export function isTransferredTicket(
  ticket: OrderTicket,
): ticket is TransferredOrderTicket {
  return ticket.status === TicketStatusEnum.Transferred;
}
